<template>
  <path
    d="M19.3 4.71022C18.91 4.32022 18.28 4.32022 17.89 4.71022L7 15.5902V10.0002C7 9.45022 6.55 9.00022 6 9.00022C5.45 9.00022 5 9.45022 5 10.0002V18.0002C5 18.5502 5.45 19.0002 6 19.0002H14C14.55 19.0002 15 18.5502 15 18.0002C15 17.4502 14.55 17.0002 14 17.0002H8.41L19.3 6.11022C19.68 5.73022 19.68 5.09022 19.3 4.71022Z"
  />
</template>
